export default __webpack_public_path__ + "static/media/Hana_Checklist_New.df0b5f2d.png";